export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'V.E.R';
export const BUILD_NUMBER = import.meta.env.VITE_BUILD_NUMBER || 'B.L.D';
export const APP_COPYRIGHT_YEARS = '2021-2026';
// Can be overridden by VITE_IDLE_TIMEOUT environment variable.
export const IDLE_TIMEOUT = import.meta.env.VITE_IDLE_TIMEOUT || 15 * 60 * 1000;